import React from 'react';
import useProjectIdContext from '../../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';
import useSessionConnectionContext from '../SessionConnectionContextProvider/useSessionConnectionContext';
import useSessionInfoContext from '../SessionInfoContextProvider/useSessionInfoContext';
import useSessionCompliance from './Hooks/useSessionCompliance';
import { SessionComplianceContext } from './useSessionComplianceContext';

export default function SessionComplianceContextProvider({ children }: { children: React.ReactNode }) {
  const { latestMessage } = useSessionConnectionContext();
  const { session } = useSessionInfoContext();
  const { projectId } = useProjectIdContext();
  const value = useSessionCompliance(latestMessage, session, projectId);

  return (
    <SessionComplianceContext.Provider value={value}>
      {children}
    </SessionComplianceContext.Provider>
  );
}
